import type { GraphStoreClient } from "graph-store"
import * as persistedData from "./persisted-data"

const LOCK_NAME = "spaestiem-hydrate"

// Re-loads the most-recently-persisted RDF file into the shared graph store
// on a cold start. Safe to call from every page bootstrap: when another tab
// has already populated the SharedWorker, the size check short-circuits.
//
// navigator.locks serializes simultaneously-opening tabs so the same file
// can't be loaded twice. The inner size() re-check catches the case where
// a peer hydrated while we were waiting for the lock.
export async function hydrateGraphStore(
  graphStore: GraphStoreClient,
): Promise<void> {
  if ((await graphStore.size()) > 0) return
  if (!persistedData.isSupported()) return

  const runHydrate = async () => {
    if ((await graphStore.size()) > 0) return
    const loaded = await persistedData.load()
    if (!loaded) return
    try {
      await graphStore.loadFile(loaded.file, { format: loaded.format })
    } catch (e) {
      console.error("hydrate: failed to load persisted data", e)
    }
  }

  if (typeof navigator !== "undefined" && navigator.locks?.request) {
    await navigator.locks.request(LOCK_NAME, runHydrate)
  } else {
    await runHydrate()
  }
}
